import { Component, OnInit, Input, ViewChild, TemplateRef } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import { Store } from '@ngrx/store';
import * as fromCommonStore from '../../../store';
import * as fromRootStore from '../../../reducers';
import * as moment from 'moment';
import { HamodelModel } from '../../../model/index';
import { HamodelService, CommonService } from '../../../services/index';
import { stockUpdateModel } from '../../../model/index';


@Component({
    selector: 'client-history-tab',
    templateUrl: './client_history.component.html',
})
export class clientHistoryDeleteComponent implements OnInit {
    @Input() stockGrid: stockUpdateModel[] = [];
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input('params') params: string;
    //@Input() dataContext;

    public mode: string;
    public list: any[] = [];
    public stockList: any[] = [];
    partyCtrl: FormControl;
    typeCtrl: FormControl;
    numCtrl: FormControl;
    modelCtrl: FormControl;
    dateCtrl: FormControl;
    branchCtrl: FormControl;
    billCtrl: FormControl;
    vouNumCtrl: FormControl;
    filteredBranch: Observable<any[]>;
    isLoadMask: Promise<any>;
    stockDet: HamodelModel[];
    isLoading: boolean = false;
    filterData = {
        "search_data": ""
    };
    loadingIndicator: boolean = true;
    //reorderable: boolean = true;
    filteredParty: Observable<any[]>;
    filteredModel: Observable<any[]>;
    
    serialNoList: any[] = [];
    halistCtrl: FormControl;
    filteredHa: Observable<any[]>;
    haList: any[] = [];
    actSerialNoList = [];
    serialNoCtrl: FormControl;
    filteredSerialNo: Observable<any[]>;

    udpateSerialNoList: any[] = [];
    updateHalistCtrl: FormControl;
    updateFilteredHa: Observable<any[]>;
    updateHaList: any[] = [];
    updateActSerialNoList = [];
    updateSerialNoCtrl: FormControl;
    updateFilteredSerialNo: Observable<any[]>;

    PartyList = [];
    ModelList = [];
    typeList = [];
    folHisList : any[]= [];
    folHisArray: any[];
    descriptionDetails : any[] = [];
    AcctypeList = [];
    freetypeList = [];
    paymentList = [];
    actModelList = [];
    branchList: any[] = [];
    page = {
        limit: 25,
        count: 0,
        offset: 0,
        orderBy: 'stock_id',
        orderDir: 'desc'
    };

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('filterPanel') filterPanel;
    @ViewChild('halistAutoComp') halistAutoComp;

    columns = [];
    scrollTimeout: any;
    suppressPaging: boolean = false;
    showBranch = true;
    subscribeBranch;
    showUpdate: boolean;
    constructor(public store: Store<fromRootStore.State>, private hamodelService: HamodelService, public toasterService: ToasterService, private commonService: CommonService) {
        //FOR AUTO COMPLETE VALIDATION --- PARTY COMBO
      
        this.stockDet = [];
        // this.stockDet['mode'] = 'Add';

        this.branchCtrl = new FormControl();
        this.filteredBranch = this.branchCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterBranch(name) : this.branchList.slice());

        this.numCtrl = new FormControl('', [
            Validators.required
        ]);
        this.dateCtrl = new FormControl('', [
            Validators.required
        ]);
        this.billCtrl = new FormControl('', [
            Validators.required
        ]);
        this.vouNumCtrl = new FormControl('', [
            Validators.required
        ]);

        this.halistCtrl = new FormControl('', [
            Validators.required,
            hasValidHaModel.bind(this)
        ]);
        function hasValidHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;

            if (ModelID == "") {
                retVal = { inValidHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidHaModel: true };
            }
            return retVal;
        }
        this.filteredHa = this.halistCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterHa(name) : this.haList.slice());

        //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
        function hasValidModel(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidModel: true };
            }
            let fhalist = _.find(this.serialNoList, { 'serial_no': brandID });
            if (!fhalist) {
                retVal = { inValidModel: true };
            }
            return retVal;
        }

        this.serialNoCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);
        this.filteredSerialNo = this.serialNoCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterSerialNo(name) : this.serialNoList.slice());

        //update model name and serial no

        
        this.updateHalistCtrl = new FormControl('', [
            Validators.required,
            hasValidUpdHaModel.bind(this)
        ]);
        function hasValidUpdHaModel(input: FormControl) {
            let ModelID = input.value, retVal = null;

            if (ModelID == "") {
                retVal = { inValidUpdHaModel: true };
            }
            if (ModelID && typeof ModelID === 'string') {
                retVal = { inValidUpdHaModel: true };
            }
            return retVal;
        }
        this.updateFilteredHa = this.updateHalistCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterUpdHa(name) : this.updateHaList.slice());

        //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
        function hasValidUpdModel(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidUpdModel: true };
            }
            let fhalist = _.find(this.udpateSerialNoList, { 'serial_no': brandID });
            if (!fhalist) {
                retVal = { inValidUpdModel: true };
            }
            return retVal;
        }

        this.updateSerialNoCtrl = new FormControl('', [
            Validators.required,
            hasValidUpdModel.bind(this)
        ]);
        this.updateFilteredSerialNo = this.updateSerialNoCtrl.valueChanges
        .startWith(null)
        .map(name => name ? this.filterUpdSerialNo(name) : this.udpateSerialNoList.slice());


    }

    filterBranch(name: string) {
        name = _.escapeRegExp(name);
        return this.branchList.filter(item => (new RegExp(name, 'gi').test(item.branch_name)));
    }
    displayFn(branchID: any) {
        if (this.branchList != undefined) {
            if (branchID && this.branchList.length > 0) {
                let fitem = _.find(this.branchList, { 'branch_id': branchID });
                return fitem['branch_name'];
            }
        }
        return '';
    }
    filterHa(name: string) {
        name = _.escapeRegExp(name);
        return this.haList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }

    filterUpdHa(name: string) {
        name = _.escapeRegExp(name);
        return this.updateHaList.filter(ha => (new RegExp(name, 'gi').test(ha.model_id) || new RegExp(name, 'gi').test(ha.name)));
    }

    ngOnInit(): void {
    
        // this.stockDet['voucher_date'] = new Date();

        this.typeList = ['Delete Client History', 'Update Serial Number','Update Serial Type Free'];
        this.AcctypeList = ['HV Bill','SOA Bill','Sales Bill','Challan Out'];
        this.freetypeList = ['Yes','No'];
        

        this.subscribeBranch = this.store.select(fromCommonStore.getAllBranch).subscribe((res: any) => {
            if (_.isEmpty(res.data)) {
                return;
            }
            this.branchList = _.filter(res.data, function (obj) { return obj['is_crm_branch'] == 'Yes' });
        });

        this.columns = [
            { name: 'Description', prop: 'description', sortable: false, cellClass: 'cell-left' },
            { name: 'Type', prop: 'status_name',sortable: false, cellClass: 'cell-left' }
        ];

        this.loadChallanHaList();
        // this.halistAutoComp.optionSelected.subscribe(this.onSelectedHaList.bind(this));


    }
    
    onSelectedHaList(mdCompEvent: any) {
        let model_id = mdCompEvent.option.value,
            fhalist = _.find(this.haList, { 'model_id': model_id });

        this.stockDet['name'] = fhalist.name;
    }
    loadChallanHaList() {
        let that = this,
            data = {
                from_page: 'Ha_and_spare'
            };
        this.commonService
            .getHaModelStockHisUpd(data)
            .then(function (res: any) {
                that.haList = res['haStockModel'];
                that.actSerialNoList = res['haModelStockSerial'];
                that.halistCtrl.setValue(that.stockDet['model_id']);
                that.updateHaList = res['haStockModel'];
                that.updateActSerialNoList = res['haModelStockSerial'];
                that.updateHalistCtrl.setValue(that.stockDet['update_model_id']);
            });
    }
    
    filterSerialNo(name: string) {
        name = _.escapeRegExp(name);
        return this.serialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));
    }

    filterUpdSerialNo (name: string){
        name = _.escapeRegExp(name);
        return this.udpateSerialNoList.filter(ha => (new RegExp(name, 'gi').test(ha.serial_no)));

    }

    displaySerialNo(serial_no: number) {
        if (serial_no && this.serialNoList.length > 0) {
            let fhalist = _.find(this.serialNoList, { 'serial_no': serial_no });
            this.stockDet['model_id'] = fhalist.model_id;
            this.stockDet['serial_no'] = fhalist.serial_no;
            return fhalist['serial_no'];
        }
        return '';
    }

    displayUpdSerialNo(serial_no: number) {
        if (serial_no && this.udpateSerialNoList.length > 0) {
            let fhalist = _.find(this.udpateSerialNoList, { 'serial_no': serial_no });
            this.stockDet['update_model_id'] = fhalist.model_id;
            this.stockDet['update_serial_no'] = fhalist.serial_no;
            return fhalist['serial_no'];
        }
        return '';
    }

    displayHa(model_id: number) {
        this.serialNoList = [];
        if (model_id && this.haList.length > 0) {
            let fhalist = _.find(this.haList, { 'model_id': model_id });
            this.getModelSerialNo(model_id); //TO LOAD SERIAL NUMBER FOR THAT MODEL
            return fhalist['name'];
        }
        return '';
    }

    displayUpdHa(model_id: number) {
        this.udpateSerialNoList = [];
        if (model_id && this.updateHaList.length > 0) {
            let fhalist = _.find(this.updateHaList, { 'model_id': model_id });
            this.getUpdModelSerialNo(model_id); //TO LOAD SERIAL NUMBER FOR THAT MODEL
            return fhalist['name'];
        }
        return '';
    }
    
    getModelSerialNo(modelID) {
        let actSerialNoList = this.actSerialNoList;
        this.serialNoList = _.filter(actSerialNoList, { 'model_id': modelID });
        this.serialNoCtrl.setValue(this.stockGrid['model_id']);
    }

    getUpdModelSerialNo(modelID) {
        let updateActSerialNoList = this.updateActSerialNoList;
        this.udpateSerialNoList = _.filter(updateActSerialNoList, { 'model_id': modelID });
        this.updateSerialNoCtrl.setValue(this.stockGrid['model_id']);
    }

    searchPocList(term: string): void {
        if (term) {
            this.folHisList = this.folHisArray.filter((item) => new RegExp(term, 'gi').test(item.status_name));
            setTimeout(() => {
                document.getElementById("pocField").focus();
            }, 200);
        } else {
            this.folHisList = this.folHisArray;
        }
    }

    displayDescription(){
        if (this.stockDet['st_det_id'] == undefined || this.stockDet['st_det_id'] == '') {
            swal('WARNING', 'Please Select Client History for Delete');
            return;
        }
        let that = this;
        this.descriptionDetails =[];
        let stockDetId = this.stockDet['st_det_id'];
        this.folHisArray.forEach(function (id) {
            stockDetId.filter(function (data) {
                if(data.st_det_id == id.st_det_id){
                    that.descriptionDetails.push(id);
                }
            });

        });
        that.page.count = that.descriptionDetails.length;    
    }


    onDateChange(){
        let that = this;
        if(this.stockDet['stock_type'] == 'Update Serial Number'){
            return;
        }
        if (this.stockDet['client_no'] == undefined || this.stockDet['client_no'] == '') {
            swal('WARNING', 'Please Enter Client Number');
            return;
        }
       let data ={
        client_no : this.stockDet['client_no'],
        date: moment(this.stockDet['voucher_date']).format('YYYY-MM-DD')
       }
       this.folHisList = [];
       this.commonService
                    .getClientHistoryDetails(data)
                        .then(function(res: any) {
                            if (res.success) {
                               that.folHisList = res.data;
                               that.folHisArray =  res.data;
                            } else {
                                
                                var toast = {
                                    type: 'error',
                                    title: 'ERROR',
                                    body: res.message
                                };
                                that.toasterService.pop(toast);
                            }
                        });
    }
    onDeleteDetails(): void {
        var toast = {
            type: 'error',
            title: 'ERROR'
        };

      
        if (this.stockDet['voucher_date'] == undefined || this.stockDet['voucher_date'] == '') {
            swal('WARNING', 'Please Enter Date');
            return;
        }  
        if(this.stockDet['stock_type'] == 'Delete Client History'){
            if (this.stockDet['st_det_id'] == undefined || this.stockDet['st_det_id'] == '') {
                swal('WARNING', 'Please Select Client History for Delete');
                return;
            } 
            if (this.stockDet['client_no'] == undefined || this.stockDet['client_no'] == '') {
                swal('WARNING', 'Please Enter Client Number');
                return;
            }
        }else if(this.stockDet['stock_type'] == 'Update Serial Number'){

            if (this.stockDet['change_type'] == undefined || this.stockDet['change_type'] == '') {
                swal('WARNING', 'Please Select Change Type');
                return;
            }
            if(this.stockDet['change_type'] != 'Challan Out'){
                if (this.stockDet['client_no'] == undefined || this.stockDet['client_no'] == '') {
                    swal('WARNING', 'Please Enter Client Number');
                    return;
                }
            }
            if (this.stockDet['branch_id'] == undefined || this.stockDet['branch_id'] == '') {
                    swal('WARNING', 'Please Select Branch');
                    return;
            }
 
            if (this.stockDet['bill_no'] == undefined || this.stockDet['bill_no'] == '') {
                swal('WARNING', 'Please Enter Bill/Challan No');
                return;
            } 

            if (this.stockDet['model_id'] == undefined || this.stockDet['model_id'] == '') {
                swal('WARNING', 'Please Select Modal');
                return;
            }
            if (this.stockDet['serial_no'] == undefined || this.stockDet['serial_no'] == '') {
                swal('WARNING', 'Please Enter Serial No');
                return;
            } 
            if (this.stockDet['update_model_id'] == undefined || this.stockDet['update_model_id'] == '') {
                swal('WARNING', 'Please Select Update Model');
                return;
            }
            if (this.stockDet['update_serial_no'] == undefined || this.stockDet['update_serial_no'] == '') {
                swal('WARNING', 'Please Select Update Serial No');
                return;
            } 
        }else if(this.stockDet['stock_type'] == 'Update Serial Number'){

            if (this.stockDet['change_type'] == undefined || this.stockDet['change_type'] == '') {
                swal('WARNING', 'Please Select Change Type');
                return;
            }
            if(this.stockDet['change_type'] != 'Challan Out'){
                if (this.stockDet['client_no'] == undefined || this.stockDet['client_no'] == '') {
                    swal('WARNING', 'Please Enter Client Number');
                    return;
                }
            }
            if (this.stockDet['branch_id'] == undefined || this.stockDet['branch_id'] == '') {
                    swal('WARNING', 'Please Select Branch');
                    return;
            }
 
            if (this.stockDet['bill_no'] == undefined || this.stockDet['bill_no'] == '') {
                swal('WARNING', 'Please Enter Bill/Challan No');
                return;
            } 

            if (this.stockDet['model_id'] == undefined || this.stockDet['model_id'] == '') {
                swal('WARNING', 'Please Select Modal');
                return;
            }
            if (this.stockDet['serial_no'] == undefined || this.stockDet['serial_no'] == '') {
                swal('WARNING', 'Please Enter Serial No');
                return;
            } 
            if (this.stockDet['freeItem'] == undefined || this.stockDet['freeItem'] == '') {
                swal('WARNING', 'Please Select Free Type');
                return;
            }

        }
      

        let that = this,
        data = {
            stock_type: this.stockDet['stock_type'],
            client_no: this.stockDet['client_no'],        
            date: moment(this.stockDet['voucher_date']).format('YYYY-MM-DD'),
            st_det_id:this.stockDet['st_det_id'],
            change_type: this.stockDet['change_type'],
            freeItem: this.stockDet['freeItem'],
            bill_no: this.stockDet['bill_no'],
            model_id: this.stockDet['model_id'],
            serial_no: this.stockDet['serial_no'],
            update_model_id: this.stockDet['update_model_id'],
            update_serial_no: this.stockDet['update_serial_no'],
            branch_id: this.stockDet['branch_id']
        };

        if( this.stockDet['stock_type'] == 'Delete Client History'){

            swal({
                title: 'Are you sure to Delete?',
                text: 'You will not be able to Recover Again!',
                showCancelButton: true,
                confirmButtonText: 'Yes, Delete!',
                cancelButtonText: 'No, Keep it'
            }).then(function() {
                that.isLoading = true;
                that.isLoadMask = that.commonService
                .deleteClientFollowHistory(data)
                    .then(function(res: any) {

                        that.isLoading = false;
                        if (res.success) {
                            that.stockDet = [];
                            swal('SUCCESS', res.message, 'success');
                            that.descriptionDetails = [];
                            //  that.onReset();
                            // that.getStockList();
                        } else {
                            
                            var toast = {
                                type: 'error',
                                title: 'ERROR',
                                body: res.message
                            };
                            that.toasterService.pop(toast);
                        }
                    });
    
            }, function(dismiss) {
    
            }); 
            
        }
        else if( this.stockDet['stock_type'] == 'Update Serial Number' || this.stockDet['stock_type'] == 'Update Serial Type Free'){
            this.isLoading = true;
            this.commonService
                .updateModelSerial(data)
                .then(function (res: any) {
                    that.isLoading = false;
                    if (res.success) {
                        that.stockDet = [];
                        swal('SUCCESS', res.message, 'success');
                        //  that.onReset();
                        // that.getStockList();
                    } else {
                        
                        var toast = {
                            type: 'error',
                            title: 'ERROR',
                            body: res.message
                        };
                        that.toasterService.pop(toast);
                    }
                });



        }   
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/dataCorrection/client_history/client_history.component.ts